;; Copyright (C) 2017, Doctor Evidence. All rights reserved.

(ns dre.shared.interface.search.util
  "Utilities for blunt and pills"
  {:authors ["Jozef Wagner" "Michiel Borkent"]}
  (:require [dre.coll :refer [nn-hash-map]]
            [dre.shared.interface.search.blunt :as blunt]
            [dre.shared.interface.search.pills :as pills]
            [dre.util :refer [in? unkeyword]]))

(defn normalized-blunt
  "Returns normalized blunt from query using either pills or blueprints"
  [query]
  (when query
    (let [blueprints (pills/coerce
                      (or (:query/pills query)
                          (:query/blueprints query)))
          blunt (blunt/print (pills/provide-pills blueprints))
          blueprints (blunt/parse blunt)
          blueprint (pills/flats->pill blueprints)
          normalized (pills/normalize-blueprint blueprint)
          normalized (blunt/print (pills/provide-pills normalized))]
      normalized)))

(defn normalized-blunt-new
  "Returns normalized blunt from query using either pills or blueprints"
  [query]
  (when query
    (let [blueprints (pills/coerce
                      (or (:query/pills query)
                          (:query/blueprints query)))
          blunt (blunt/print (pills/provide-pills blueprints))
          blueprints (blunt/parse blunt)
          blueprint (pills/flats->pill blueprints)
          normalized (pills/normalize-blueprint-new blueprint)
          normalized (blunt/print (pills/provide-pills normalized))]
      normalized)))

(def blunt-key :query/normalized-blunt)

(defn assoc-blunt
  "Adds normalized blunt key/val to query. k designates the query key."
  [m k]
  (let [blunt (normalized-blunt (get m k))]
    (assoc-in m [k blunt-key] blunt)))

(defn search-query->route
  "Returns a route map from a given search query."
  [search-query roles-hash]
  (let [{:keys [:query/pills :query/query :query/type :query/order :query/viewtype :query/question :query/baq]} search-query
        query (if (in? [:articles :effects :guidances :regdocs] type)
                (blunt/print pills)
                query)]
    {:query-params (merge (nn-hash-map :query (unkeyword query)
                                       :type (unkeyword type)
                                       :roles roles-hash)
                          (when (not (nil? order))
                            (nn-hash-map :order (unkeyword order)))
                          (when (not (nil? viewtype))
                            (nn-hash-map :viewtype (unkeyword viewtype)))
                          (when (not (nil? question))
                            (nn-hash-map :question question))
                          (when (not (nil? baq))
                            (merge (nn-hash-map :baq-topic (get baq :topic)
                                                :baq-starttime (get baq :starttime))
                                   (into (nn-hash-map) (for [[idx f] (map-indexed vector (get baq :categories))]
                                                         [(keyword (str "baq-category-" (inc idx) "-type"))
                                                          (:type f)]))
                                   (into (nn-hash-map) (for [[idx f] (map-indexed vector (get baq :categories))]
                                                         [(keyword (str "baq-category-" (inc idx) "-blunt"))
                                                          (:blunt f)])))))}))

(defn semantic-search-query->route
  "Returns a route map from a given search query."
  [search-query roles-hash]
  (let []
    {:query-params (nn-hash-map :free-text-query search-query
                                :roles roles-hash)}))
;;;; Scratch

(comment
  #?(:clj (require '[dre.app.service :as svc]))
  (def blunt "ss(f9417fea-1e6a-11e9-aabd-0242ac120005).x(or).ss(99acfbe6-fc7c-11e8-8f51-0242ac12000a)")
  (-> blunt
      blunt/parse
      pills/flats->pill
      pills/normalize-blueprint
      pills/provide-pills
      blunt/print)
  #?(:clj (svc/hard-reset))
  )
